import React from 'react';
import Grow from '@material-ui/core/Grow';
import MaterialDialog from '@material-ui/core/Dialog';

const Transition = React.forwardRef((props, ref) => <Grow direction="up" ref={ref} {...props} />);

const Dialog = ({ children, ...props }) => (
  <MaterialDialog {...props} TransitionComponent={Transition}>
    {children}
  </MaterialDialog>
);

Dialog.propTypes = MaterialDialog.propTypes;

Dialog.defaultProps = MaterialDialog.defaultProps;

export default Dialog;
